<template>
  <div>
    <slot name="noday">
      <div class="flex_end los_box bs_box">
        <div class="flex_start flex_center_align">
          <span class="change_title">表示切替</span>
          <slot name="basebtn"></slot>
          <span
            :class="[noDaySwitch ? 'on' : 'off']"
            class="no_day flex_start flex_center_align"
            @click="switchBtnDay"
          >
            <svg-icon
              :icon-class="noDaySwitch ? 'eye_2_line' : 'eye_close_line'"
              class="iconName"
            ></svg-icon>
            <span class="look_word">不可日</span>
          </span>
        </div>
      </div>
    </slot>
    <div ref="calendar" class="calendar_main">
      <div
        class="header flex_center_align"
        :class="[changeShow ? 'flex_space' : 'flex_center']"
      >
        <slot v-if="changeShow" name="left">
          <!-- <div class="h_left h_common" @click="beforeMonth">前月</div> -->
          <el-button
            type="primary"
            class="secondary_but flex_center_align"
            @click="beforeMonth"
          >
            <svg-icon
              icon-class="left_line_84"
              class="secondary_but_icon"
            ></svg-icon>
            <div class="secondary_but_text flex_center_align">前月</div>
          </el-button>
        </slot>
        <div class="h_title">{{ times }}</div>
        <slot v-if="changeShow" name="right">
          <!-- <div class="h_right h_common" @click="afterMonth">翌月</div> -->
          <el-button
            type="primary"
            class="secondary_but flex_center_align"
            @click="afterMonth"
          >
            <div class="secondary_but_text flex_center_align">翌月</div>
            <svg-icon
              icon-class="right_line_84"
              class="secondary_but_icon"
            ></svg-icon>
          </el-button>
        </slot>
      </div>
      <div class="week_box flex_space">
        <div
          v-for="(item, index) in weeks"
          :key="index"
          class="week_item"
          :class="{ red: item.val == '0' }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="day_box flex_start">
        <div
          v-for="(item, index) in dayList"
          :key="index"
          class="day_item"
          :class="sumClass(item, index)"
          :style="{
            height: changeHeight ? '260px' : '200px',
          }"
          @click="dateItemClick(item)"
          @dblclick="openDaySelect(item)"
        >
          <template v-if="type == 'PWS02G06'">
            <div class="flex_space flex_center_align">
              <span class="day_title">{{ item.val }}</span>
              <div v-if="item.canwork == 1" class="mk_box blue"></div>
              <div v-if="item.canwork == 2" class="mk_box gray"></div>
              <div v-if="item.canwork == 3" class="mk_box red"></div>
            </div>
          </template>
          <template v-else>
            <span class="day_title">{{ item.val }}</span>
          </template>
          <div class="time_box">
            <div
              v-if="item.isNoDay && noDaySwitch && item.val"
              class="flex_colum"
            >
              <div
                v-for="(no, noIndex) in item.contentList"
                :key="noIndex"
                class="time_no flex_colum"
              >
                <div>
                  {{ no.title }}
                </div>
                <div v-if="no.key">({{ no.key }})</div>
              </div>
            </div>
            <el-tooltip
              v-for="(time, sindex) in item.timeList"
              :key="sindex"
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                {{ getTimeContent(time) }}
              </div>
              <div
                :class="[
                  { reset_active: time.active },
                  'time_item',
                  'flex_center_align',
                ]"
              >
                {{ time.time }}
              </div>
            </el-tooltip>
          </div>
          <item
            v-if="item.dataList.length > 0"
            :data-list="item.dataList"
          ></item>
          <div v-if="item.val && item.otherList.length > 0" class="ionc_bottom">
            <div class="flex_end flex_center_align">
              <span class="yuding">他{{ item.otherList.length }}件の予定</span>
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">すべての予定を見る</div>
                <div class="icon_box" @click="openSchedule(item)">
                  <!-- <img src="~@/assets/images/r14.png" alt="" /> -->
                  <svg-icon
                    icon-class="more_2_line"
                    class="icon_box_svg"
                  ></svg-icon>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <day ref="dayMode" v-bind="$attrs"></day>
      <daySc ref="daySc" v-bind="$attrs"></daySc>
      <schedule-detail
        :schedule-data="scheduleData"
        :visible="visibleChildren"
      ></schedule-detail>
    </div>
  </div>
</template>

<script>
  import request from '@/utils/request'
  export default {
    name: 'VabCalendar',
    inject: {
      vmData: {
        default: null,
      },
    },
    props: {
      changeShow: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        times: '',
        year: null,
        // 不可日
        noDaySwitch: true,
        weeks: [
          {
            name: '日',
            val: 0,
          },
          {
            name: '月',
            val: 1,
          },
          {
            name: '火',
            val: 2,
          },
          {
            name: '水',
            val: 3,
          },
          {
            name: '木',
            val: 4,
          },
          {
            name: '金',
            val: 5,
          },
          {
            name: '土',
            val: 6,
          },
        ],
        dayList: [],
        list: [],
        noDayList: [],
        calendarList: [],
        scheduleData: {},
        visibleChildren: false,
        dayType: null,
        changeHeight: false,
      }
    },
    computed: {
      sumClass() {
        return function (row, index) {
          let classData = {}
          if ((index + 1) % 7 == 0) {
            classData.noborder = true
          }
          if (row.week == 0) {
            classData.weekri = true
          }
          if (row?.isNoDay && this.noDaySwitch && row.val) {
            classData.weekno = true
          }
          if (row?.canwork && row?.canwork == 1) {
            classData.canwork1 = true
          }
          if (row?.canwork && row?.canwork == 3) {
            classData.canwork3 = true
          }
          return classData
        }
      },
      showBoxShift() {
        return function (row, val) {
          if (row.isxwList.shift() == val) {
            return true
          } else {
            return false
          }
        }
      },
      partnerCdList() {
        return this.$store.getters['user/bizConnectionCdList']
      },
    },
    mounted() {
      this.type = this.$route.name
    },
    methods: {
      // 日替わり不可です
      switchBtnDay() {
        this.noDaySwitch = !this.noDaySwitch
      },
      dateItemClick(item) {
        if (!item.val || this.type != 'PWS02G06') return
        if (item.week == 0) {
          item.canwork = item.canwork == 3 ? 2 : 3
        } else {
          item.canwork = item.canwork == 1 ? 2 : 1
        }
      },
      // 设置候補数据
      setWattingData(data) {
        this.list.filter((item) => {
          if (data.type === item.type) {
            item.start = data.start
            item.end = data.end
          }
        })
        this.getTimes()
      },
      // 设置候希望日・
      setHopeData(data) {
        this.list = [{ ...data }]
        this.getTimes()
      },
      // 清空绘制的展示
      clearFillForm(list) {
        if (list) {
          this.list = list
        }
        if (
          !this.$baseLodash.isNull(this.vmData) &&
          this.isEqualCodeEnum(
            this.getFieldValue(
              'demandBaseIdModel.demandType',
              this.vmData.info
            ),
            this.$divisions.demandTypeEnum.enum_2
          )
        ) {
          this.changeHeight = true
        } else {
          this.changeHeight = false
        }
        this.dayList.filter((item) => {
          item.dataList = []
        })
        this.fillForm()
        this.$forceUpdate()
      },
      // 获取当前年月
      getTimes(val) {
        return new Promise((resolve) => {
          this.dayList = []
          let date = this.$dayjs(val).format('YYYY-MM-DD')
          let year = this.$dayjs(date).format('YYYY')
          this.year = year
          let month = this.$dayjs(date).format('M')
          this.times = year + '年' + month + '月'
          this.currentTime = year + '-' + month
          this.getCurrentMonthDays(year, month)
          resolve()
        })
      },
      // 获取当前月中的天数
      getCurrentMonthDays(year, month) {
        this.allDays = this.$dayjs(this.currentTime).daysInMonth()
        this.getOneDay(year, month)
      },
      // 数据处理
      getOneDay(year, month) {
        let myDate = new Date(`${year}/${month}/01`)
        let $index = myDate.getDay()
        let day = 0
        let num = Math.ceil((this.allDays + $index) / 7) * 7
        let $arr = Array.apply(null, { length: num })
        $arr.forEach((i, index) => {
          if (index >= $index) {
            day++
            if (day <= this.allDays) {
              let str = this.currentTime + '-' + (day < 10 ? '0' + day : day)
              const week = this.getWeekByDay(new Date(str))
              let data = {
                val: day,
                week: week,
                isNoDay: false,
              }
              data.timeList = []
              data.otherList = []
              data.contentList = []
              data.time = this.$dayjs(str).format('YYYY-MM-DD')
              // 作業可能日回答
              if (this.type == 'PWS02G06') {
                data.canwork = 2
              }
              this.dayList.push(data)
            } else {
              this.dayList.push({})
            }
          } else {
            this.dayList.push({})
          }
        })
        this.fillForm()
      },
      // 获取数据渲染计划列表
      fillForm() {
        let sortArr = (a, b) => {
          return a.start - b.start
        }
        let arr = [].concat(this.list)
        let list = arr.sort(sortArr)
        this.dayList.filter((el) => {
          el.dataList = []
          list.forEach((i, nIndex) => {
            if (
              !i.start ||
              !i.end ||
              !i ||
              i.start == 'Invalid Date' ||
              i.end == 'Invalid Date'
            )
              return
            // let left = this.$dayjs(el.time).isSameOrAfter(i.start)
            // let right = this.$dayjs(el.time).isSameOrBefore(i.end)
            if (
              this.$dayjs(el.time).isBetween(
                this.$dayjs(i.start).format(this.$const.dateFormatYYYYMMDD),
                this.$dayjs(i.end).format(this.$const.dateFormatYYYYMMDD),
                null,
                '['
              ) &&
              el.val
            ) {
              let obj = { ...i }
              if (this.$dayjs(el.time).isSame(i.start)) {
                obj.isFrist = true
              } else {
                obj.isFrist = false
              }
              let tempType = this.$baseLodash.trimStart(obj.type, 'watting')
              // 希望日と候補日の区別，候補日はindex加算による，希望日はdataListを通る長さ（1つだけ）
              if (tempType !== 'hope') {
                if (tempType.length > 0) {
                  if (typeof this.dayType !== 'boolean') {
                    this.dayType = true
                  }
                  obj.index = el.dataList ? el.dataList.length : 0
                } else {
                  obj.index = nIndex
                }
              } else {
                obj.index = !this.dayType ? list.length - 1 : 1
              }
              if (this.$dayjs(el.time).isSame(i.end)) {
                obj.isEnd = true
              } else {
                obj.isEnd = false
              }
              el.dataList.push(obj)
            }
          })
        })
      },
      // 伝来日から曜日を取得する
      getWeekByDay(date) {
        return date.getDay()
      },
      // 弾窓を開ける日付の設定
      openDaySelect(item) {
        if (!item && !item.val) return
        if (this.type == 'PWS02G02') {
          // 調整済み 無効化
          if (
            this.isEqualCodeEnum(
              this.vm.info.adjScheduleStatus,
              this.$divisions.adjScheduleStatusEnum.enum_4
            )
          )
            return
          this.$refs.dayMode.initData({
            list: this.list,
            vm: this,
          })
        }
        if (this.type == 'PWS02G03') {
          // 調整済み 無効化
          if (
            this.isEqualCodeEnum(
              this.vm.info.adjScheduleStatus,
              this.$divisions.adjScheduleStatusEnum.enum_4
            )
          )
            return
          this.$refs.daySc.initData({
            list: this.list,
            vm: this,
            parentVm: this.vm,
          })
        }
      },
      // 前月
      beforeMonth() {
        this.dayList = []
        let newMonth = this.$dayjs(this.currentTime).subtract(1, 'month')
        let year = this.$dayjs(newMonth).format('YYYY')
        let month = this.$dayjs(newMonth).format('MM')
        this.times = year + '年' + this.$dayjs(newMonth).format('M') + '月'
        this.currentTime = year + '-' + month
        this.getCurrentMonthDays(year, month)
        if (this.vm) {
          let info = {
            requestYearMonth: this.$dayjs(newMonth).format(
              this.$const.dateFormatYYYYMMDD
            ),
            buildingCd: this.getFieldValue('buildingCd', this.vm?.paramsData),
            sectionCd: this.getFieldValue('sectionCd', this.vm?.paramsData),
          }
          this.vm.getCalendarList(info)
          this.clearFillForm()
        }
      },
      // 翌月
      afterMonth() {
        this.dayList = []
        let newMonth = this.$dayjs(this.currentTime).add(1, 'month')
        let year = this.$dayjs(newMonth).format('YYYY')
        let month = this.$dayjs(newMonth).format('MM')
        this.times = year + '年' + this.$dayjs(newMonth).format('M') + '月'
        this.currentTime = year + '-' + month
        this.getCurrentMonthDays(year, month)
        if (this.vm) {
          let info = {
            requestYearMonth: this.$dayjs(newMonth).format(
              this.$const.dateFormatYYYYMMDD
            ),
            buildingCd: this.getFieldValue('buildingCd', this.vm?.paramsData),
            sectionCd: this.getFieldValue('sectionCd', this.vm?.paramsData),
          }
          this.vm.getCalendarList(info)
          this.clearFillForm()
        }
      },
      setCanWorke(list) {
        let timeArr = list.map((item) =>
          Number(this.$dayjs(item.dateString).format('D'))
        )
        if (this.dayList.length > 0) {
          this.dayList.filter((item) => {
            if (timeArr.includes(item.val)) {
              if (item.week == 0) {
                item.canwork = 3
              } else {
                item.canwork = 1
              }
            }
          })
        }
      },
      setPageData(data) {
        this.pageData = data
      },
      setCalenderTime(list, vm) {
        this.calendarList = list
        if (this.dayList.length == 0) return
        this.dayList.filter((item) => {
          if (item?.allTimeList) {
            item.allTimeList = []
          }
          if (item?.otherList) {
            item.otherList = []
          }
          if (item?.timeList) {
            item.timeList = []
          }
        })
        if (vm) {
          this.vm = vm
          this.$nextTick(() => {
            this.getNoDayList()
          })
        }
      },
      async getNoDayList() {
        if (this.pageData?.buildingCd) {
          await this.getDayTotal()
        } else {
          this.dateSlice()
        }
      },
      dateSlice() {
        this.dayList.filter((item) => {
          this.calendarList.filter((row) => {
            if (item.time == row.date) {
              item.allTimeList = row.timePeriodList
              if (row.timePeriodList.length > 2 && item.isNoDay) {
                item.timeList = this.$baseLodash.slice(row.timePeriodList, 0, 2)
                item.otherList = this.$baseLodash.drop(row.timePeriodList, 2)
              } else if (row.timePeriodList.length > 3) {
                item.timeList = this.$baseLodash.slice(row.timePeriodList, 0, 3)
                item.otherList = this.$baseLodash.drop(row.timePeriodList, 3)
              } else {
                item.timeList = row.timePeriodList
              }
            }
          })
        })
      },
      // 不可日取得
      async getDayTotal() {
        let data = {
          workYm: this.$dayjs(this.pageData.requestYearMonth).format('YYYYMM'),
          buildingCd: this.pageData.buildingCd,
          weekdayConditionSpecifyModel:
            this.pageData.weekdayConditionSpecifyModel,
          weekdayConditionSpecifySpotModel:
            this.pageData.weekdayConditionSpecifySpotModel,
          purchaseOrderDepCd: this.pageData.purchaseOrderDepCd,
        }
        let res = await request({
          url:
            this.$route.meta?.cname == 'rc'
              ? '/api/works/unavailable/day-rc/total'
              : '/api/works/unavailable/day/total',
          method: 'post',
          data,
        })
        if (res && res.length > 0) {
          this.noDayList = res.filter((item) => !item.available)
          this.$nextTick(() => {
            this.dayList.filter((item) => {
              res.filter((no) => {
                let time = this.$dayjs(item.time).format(
                  this.$const.dateFormatYYYYMMDD
                )
                let nodate = this.$dayjs(no.date).format(
                  this.$const.dateFormatYYYYMMDD
                )
                if (time == nodate && !no.available) {
                  item.isNoDay = true
                  let cname = this.$route.meta?.cname
                  if (cname && cname == 'sc') {
                    item.contentList = [{ title: '建物不可日' }]
                  }
                  if (cname && cname == 'rc') {
                    item.contentList = [{ title: '点検不可日' }]
                  }
                }
              })
            })
            // 不可日和予定的位置 7227
            this.dateSlice()
          })
          this.$forceUpdate()
        }
      },
      setDrawTimeList(list) {
        this.list = list
        this.fillForm()
      },
      selectAll() {
        this.dayList.forEach((item) => {
          if (item.val > 0) {
            if (item.week == 0) {
              item.canwork = 3
            } else {
              item.canwork = 1
            }
          }
        })
      },
      clearAll() {
        this.dayList.forEach((item) => {
          if (item.val > 0) {
            item.canwork = 2
          }
        })
      },
      getPossibleDateAnswerList() {
        let list = []
        this.dayList.filter((item) => {
          if (item.canwork == 3 || item.canwork == 1) {
            let data = {
              dateString: this.$dayjs(item.time).format('YYYY/MM/DD'),
              selectFlag: 1,
              dayOfWeek: item.week,
            }
            list.push(data)
          }
        })
        return list
      },
      openSchedule(data) {
        this.scheduleData = data
        this.visibleChildren = true
      },
      update() {
        this.visibleChildren = false
      },
      getTimeContent(data) {
        if (data.active) return data.time + '/' + data.content
        if (
          this.partnerCdList?.length > 0 &&
          this.partnerCdList.find((item) => item == data.partnerCd)
        ) {
          return data.time + '/' + data.content
        } else {
          return data.time + '/' + '予定あり'
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .calendar_main {
    border: 1px solid #d1dae1;
    border-radius: 4px;
    overflow: hidden;
    .header {
      padding: 16px;
      .h_title {
        font-weight: 600;
        font-size: 16px;
        color: #003350;
      }
      .h_common {
        font-weight: 500;
        font-size: 13px;
        color: #848484;
        cursor: pointer;

        &.h_left {
          padding-left: 15px;
          background: url('~@/assets/images/r_left.png') left 1px no-repeat;
        }
        &.h_right {
          padding-right: 15px;
          background: url('~@/assets/images/r_right.png') right 1px no-repeat;
        }
      }
    }
    .week_box {
      width: 100%;
      padding: 5px 0;
      .week_item {
        width: 14.28%;
        font-size: 13px;
        text-align: center;
        color: #666666;
        &.red {
          color: #ea5b5c;
        }
      }
    }
    .day_box {
      width: 100%;
      flex-wrap: wrap;
      .yuding {
        font-weight: 400;
        font-size: 12px;
        color: #848484;
        padding-right: 5px;
      }

      .day_item {
        width: 14.28571428%;
        height: 200px;
        border: 1px solid #d1dae1;
        position: relative;
        padding: 6px;
        box-sizing: border-box;
        border-left: none;
        border-bottom: none;
        cursor: pointer;
        &.noborder {
          border-right: none;
        }
        &.weekri {
          background: #fff6f6;
        }
        &.weekno {
          background: #f7f7f7 !important;
        }
        &.canwork1 {
          background: linear-gradient(
            180deg,
            rgba(236, 245, 255, 0.5) 0%,
            rgba(216, 234, 255, 0.5) 100%
          );
        }
        &.canwork3 {
          background: linear-gradient(
            180deg,
            rgba(255, 246, 246, 0.5) 0%,
            rgba(255, 234, 238, 0.5) 100%
          );
        }
        .day_title {
          font-weight: 500;
          font-size: 13px;
          text-align: center;
          color: #666666;
          display: block;
          text-align: left;
        }
        .time_box {
          padding-top: 4px;
          .time_item {
            font-weight: 500;
            font-size: 13px;
            color: #5f839f;
            width: 100%;
            height: 24px;
            background: rgba(0, 0, 0, 0.03);
            border-left: 2px solid #bdccd7;
            padding-left: 8px;
            margin-bottom: 2px;
          }
          .time_no {
            font-size: 13px;
            color: #bababa;
            line-height: 24px;
            height: 24px;
            margin-bottom: 2px;
          }

          .reset_active {
            background: #fa7830e6 !important;
            color: #fff !important;
          }
        }
        .ionc_bottom {
          position: absolute;
          right: 6px;
          bottom: 8px;
          .icon_box {
            width: 24px;
            height: 24px;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon_box_svg {
              font-size: 18px;
              color: #5f839f;
            }
          }
          &:hover {
            .icon_box {
              background: rgba(0, 0, 0, 0.07);
            }
          }
        }
      }
    }
  }
</style>
